export const meters2kilometers = number => number / 1000;

export const kilometers2meters = number => number * 1000;
